import axios from "axios";
import { BASE_URL } from "../../helper/base-url";

export const getSkills = async () => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const workshop_benefits = await axios
    .get(`${BASE_URL}skills`, {
      headers: {
        Authorization: `Bearer ${userData?.token}`,
        "x-api-key": process.env.REACT_APP_API_KEY,
        "x-client-secret": process.env.REACT_APP_CLIENT_SECRET,
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return workshop_benefits;
};

export const storeSkills = async (data) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const workshop_benefits = await axios
    .post(`${BASE_URL}skills`, data, {
      headers: {
        Authorization: `Bearer ${userData?.token}`,
        "x-api-key": process.env.REACT_APP_API_KEY,
        "x-client-secret": process.env.REACT_APP_CLIENT_SECRET,
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return workshop_benefits;
};

export const deleteSkills = async (id) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const workshop_benefits = await axios
    .delete(`${BASE_URL}skills/${id}`, {
      headers: {
        Authorization: `Bearer ${userData?.token}`,
        "x-api-key": process.env.REACT_APP_API_KEY,
        "x-client-secret": process.env.REACT_APP_CLIENT_SECRET,
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return workshop_benefits;
};

export const getSkillsDropdown = async (q) => {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const workshop_benefits = await axios
    .get(`${BASE_URL}skills-dropdown`, {
      params: { q: q || "" },
      headers: {
        Authorization: `Bearer ${userData?.token}`,
        "x-api-key": process.env.REACT_APP_API_KEY,
        "x-client-secret": process.env.REACT_APP_CLIENT_SECRET,
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
  return workshop_benefits;
};
